
import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { ScrollArea } from "@/components/ui/scroll-area";
import { AutomatedMessage } from "./message-utils/types";
import AnalyticsChart from "./analytics/AnalyticsChart";
import AnalyticsDetails from "./analytics/AnalyticsDetails";

interface MessageAnalyticsDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  message: AutomatedMessage | null;
}

const MessageAnalyticsDialog = ({ open, onOpenChange, message }: MessageAnalyticsDialogProps) => {
  if (!message) return null;
  
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[650px] max-h-[80vh]">
        <DialogHeader>
          <DialogTitle>Métricas de Desempenho</DialogTitle>
        </DialogHeader>

        <Tabs defaultValue="chart" className="w-full">
          <TabsList className="grid grid-cols-2 mb-4">
            <TabsTrigger value="chart">Gráfico</TabsTrigger>
            <TabsTrigger value="details">Detalhes</TabsTrigger>
          </TabsList>
          
          <TabsContent value="chart">
            <AnalyticsChart message={message} />
          </TabsContent>
          
          <TabsContent value="details" className="h-full">
            <ScrollArea className="h-[350px] pr-4">
              <AnalyticsDetails message={message} />
            </ScrollArea>
          </TabsContent>
        </Tabs>
      </DialogContent>
    </Dialog>
  );
};

export default MessageAnalyticsDialog;
